import crudApi from "@serie3/common/api/crudApi";
import DocumentsEndpoints from "../endpoints";

/** What setPreviewFile gets when the API has no bytes for the row (404: gone from disk, 204: not previewable). */
export const missingPreview = (status) => ({ url: null, type: "", missing: true, status });

/**
 * Loads a document's bytes into an object URL. `binaryEndpoint` defaults to
 * the personal preview route; group views pass their member-gated one.
 * A row whose file is gone answers 404; the preview then carries
 * `missing: true` and no URL, so views render a placeholder instead of
 * breaking.
 */
const getFile = async (
  file,
  setPreviewTitle,
  setPreviewFile,
  setShowFilePreview = null,
  binaryEndpoint = DocumentsEndpoints.show
) => {
  const fileResponse = await crudApi.getBinary(binaryEndpoint + file.id);

  if (!fileResponse.ok || fileResponse.status === 204) {
    setPreviewTitle(file.original_name);
    setPreviewFile(missingPreview(fileResponse.status));
    if (typeof setShowFilePreview === "function") {
      setShowFilePreview(true);
    }
    return;
  }

  // Create a Blob from the response data and detect the file type
  const blob = new Blob([fileResponse.data], {
    type: fileResponse.headers["content-type"],
  });
  const url = URL.createObjectURL(blob);

  setPreviewTitle(file.original_name);
  setPreviewFile({ url, type: fileResponse.headers["content-type"] }); // Store both URL and type

  if (typeof setShowFilePreview === "function") {
    setShowFilePreview(true); // Show the modal
  }
};

export default getFile;
